import ChipsField from './ChipsField'
export default ({ data, labelField, max }) => <div style={{ display: "flex", columnGap: 4 }}>
  <ChipsField data={data.slice(0, max)} labelField={labelField} />
  {data.length > max ? <span>+ {data.length - max}</span> : null}
</div>